export interface ICreateAccountRequest {
  newPatient: boolean;
  clinicalRequest: any;
  userName: string;
  password: string;
  oneTimeCode: string;
}

export interface ICreateAccountResponse {
  result: CreateAccountResult;
  patientEmailForAccountNotification: string;
}

export enum CreateAccountResult {
  AccountCreatedSuccessfully,
  PatientAccountAlreadyExists,
  UserNameAlreadyInUse,
  CreationOfNewPatientNotAllowed,
  CreationOfAccountNotAllowed,
  MultiplePatientsFound,
  FailedToCreatePatient,
  OneTimeCodeIsExpired,
  OneTimeCodeIsInvalid,
  PasswordIsInvalid
}

export interface ILocatePatientResponse {
  patientExists: boolean;
  accountExists: boolean;
  multiplePatientsFound: boolean;
}

export interface IPatientSearchResult {
  patient: any;
  locatePatientRes: ILocatePatientResponse;
}

export enum ContactType {
  MobilePhone,
  Email
}

export interface IOneTimeCodeGenerationResponse {
  success: boolean;
  contactInfo: string;
  contactType: ContactType;
}

export interface IOneTimeCodeDetails {
  clinicalRequest: any;
  oneTimeCode: string;
}

export interface IOneTimeCodeValidationRequest {
  clinicalRequest: any;
  oneTimeCode: string;
}

export interface IOneTimeCodeValidationResponse {
  valid: boolean;
  expired: boolean;
}

export interface IChangePasswordRequest {
  oneTimeCode: string;
  userName: string;
  password: string;
}

export interface IChangePasswordResponse {
  result: ChangePasswordResult;
  details: string;
}

export enum ChangePasswordResult {
  PasswordChangedSuccessfully,
  OneTimeCodeIsExpired,
  OneTimeCodeIsInvalid,
  NewPasswordRecentlyUsed,
  PasswordIsInvalid
}

